import { Hourglass, X } from "lucide-react";
import { addDays, format } from "date-fns";

export default function FreePlanAlert({setFreePlanAlert, trialEndDays}: {setFreePlanAlert: (value: boolean) => void, trialEndDays: number}) {

  const daysToEndDate = addDays(new Date(), trialEndDays);
  const formattedDate = format(daysToEndDate, "do MMMM");

  return (
    <div className="w-full sm:w-[80%] flex items-start justify-between gap-3 bg-yellow-100 border-l-4 border-yellow-500 text-[#143887] p-4 rounded-lg">
        <div className="flex items-start gap-3 sm:gap-4 min-w-0">
            <span className="w-8 h-8 flex-shrink-0 bg-white border border-gray-500 rounded-full flex justify-center items-center"><Hourglass size={16}/></span>
            <div className="min-w-0">
                <h2 className="text-sm sm:text-[16px] font-bold mb-2 sm:mb-3">Your free trial ends in {trialEndDays} days on {formattedDate}.</h2>
                <p className="text-sm">Upgrade now to keep using Fleetrify's powerfull features</p>
            </div>
        </div>
        <button onClick={()=>setFreePlanAlert(false)} className="flex-shrink-0"><X size={16} /></button>
    </div>
  )
}